"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreditCard_1 = require("./modules/web/CreditCard");
var Offline_1 = require("./modules/web/Offline");
var Wallets_1 = require("./modules/web/Wallets");
var MethodFactory = /** @class */ (function () {
    function MethodFactory() {
        var _this = this;
        this.methods = {};
        this.methodDefs = function (methodId) {
            var refs = {
                creditCard: function (props) { return (new CreditCard_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    localizeError: props.localizeError,
                    linkToIframe: props.creditCardFormUrl,
                    query: props.query,
                    orderId: props.query.orderId || props.snapshotId,
                    appId: props.appId,
                    appInstanceId: props.appInstanceId,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    selector: props.selector,
                    type: props.type,
                    host: props.host
                })); },
                offline: function (props) { return (new Offline_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    orderId: props.query.orderId || props.snapshotId,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    host: props.host
                })); },
                wallet: function (props) { return (new Wallets_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    orderId: props.query.orderId || props.snapshotId,
                    walletPaymentInNewTab: props.walletPaymentInNewTab,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    host: props.host
                })); }
            };
            return refs[methodId] || refs.wallet;
        };
        this.addMethod = function (methodId, props) {
            var method = _this.methodDefs(methodId);
            var methodInstance = method(props);
            methodInstance.setup();
            _this.methods[methodId] = methodInstance;
            return methodInstance;
        };
        this.getMethod = function (methodId) { return _this.methods[methodId]; };
        this.getMethods = function () { return Object.keys(_this.methods).map(function (key) { return _this.methods[key]; }); };
        this.removeById = function (methodId) {
            if (_this.getMethod(methodId)) {
                _this.getMethod(methodId).remove();
                delete _this.methods[methodId];
            }
        };
        this.remove = function (methodId) {
            if (methodId) {
                _this.removeById(methodId);
            }
            else {
                Object.keys(_this.methods || {}).forEach(function (key) { return _this.removeById(key); });
            }
        };
    }
    return MethodFactory;
}());
exports.default = MethodFactory;
//# sourceMappingURL=MethodFactory.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/MethodFactory.js
// module id = 383
// module chunks = 0 1